import { useEffect, useRef } from 'react';
import { useData } from 'hooks/useData';
import Menu from 'components/3catinfo/Menu';

const MenuError = (props) => {
    const menuRef = useRef(null);
    const urlMenuSeo =
        '%%dataResources.apiCCMA%%/esnoticia?_format=json&frontal=n324-seo-notdia&version=2.0&cache=180&https=true&pagina=1';
    const urlMenuTemesDestacats =
        '%%dataResources.apiCCMA%%/esnoticia?_format=json&frontal=n324-portada-esnoticia&version=2.0&cache=180&https=true&pagina=1&items_pagina=6';
    const urlMenuTemesGenerics =
        '%%dataResources.apiCCMA%%/generics?_format=json&mapping=mapping&fitxer=mapping_menu_temes_generics&cache=600';
    const { data: itemsMenuSeo, getDades: getDadesMenuSeo } = useData();
    const { data: itemsMenuTemesDestacats, getDades: getDadesMenuTemesDestacats } = useData();
    const { data: itemsMenuTemesGenerics, getDades: getDadesMenuTemesGenerics } = useData();

    const requiredServicesForMenu = useRef(null);

    useEffect(() => {
        getDadesMenuSeo(urlMenuSeo);
        getDadesMenuTemesDestacats(urlMenuTemesDestacats);
        getDadesMenuTemesGenerics(urlMenuTemesGenerics);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleMenuClick = (e) => {
            if (menuRef?.current?.contains(e.target)) {
                const link = e.target.closest('a');
                if (link?.href) {
                    const href = link.getAttribute('href');
                    if (href.startsWith('/')) {
                        e.preventDefault();
                        window.location.href = href;
                    }
                }
            }
        };

        document.addEventListener('click', handleMenuClick);

        //Serveis pel menu en la plana d'error
        const requiredServices = ['login']; // Llista de serveis
        const servicesAvailability = requiredServices.map((service) => ({ [service]: true }));
        requiredServicesForMenu.current = {
            areAllServicesAvailable: true, // Sempre true o false sense calculs
            servicesAvailability
        };

        return () => {
            document.removeEventListener('click', handleMenuClick);
        };
    }, []);

    return (
        <>
            {itemsMenuTemesGenerics && itemsMenuSeo && itemsMenuTemesDestacats && (
                <span ref={menuRef}>
                    <Menu
                        temesGenerics={itemsMenuTemesGenerics?.items?.temesgenerics}
                        temesDestacats={itemsMenuTemesDestacats}
                        informatius={itemsMenuTemesGenerics?.items?.informatius}
                        destacatsPortal={itemsMenuTemesGenerics?.items?.destacatsportal}
                        podcasts={itemsMenuTemesGenerics?.items?.podcasts}
                        itemsSeo={itemsMenuSeo}
                        requiredServices={requiredServicesForMenu.current}
                    />
                </span>
            )}
        </>
    );
};

export default MenuError;
